import { SignInPage } from '@backstage/core-components';
import {
  type ExtensionDefinition,
  githubAuthApiRef,
  microsoftAuthApiRef,
} from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

export const signInPageExtension: ExtensionDefinition =
  SignInPageBlueprint.make({
    params: {
      loader: async () => props => (
        <SignInPage
          {...props}
          auto
          providers={[
            {
              id: 'github-auth-provider',
              title: 'GitHub',
              message: 'GitHub signin. Recommended for OBOS developers',
              apiRef: githubAuthApiRef,
            },
            {
              id: 'microsoft-auth-provider',
              title: 'Microsoft',
              message: 'EntraID siginin. For non developers',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      ),
    },
  });
